export default __webpack_public_path__ + "static/media/unbindingcharm.010153f4.png";